<template>
  <div class="cgzs">
    <div class="w1200 bt">
      <h3>成果展示</h3>
      <span>ACHIEVEMENT DISPLAY</span>
      <img src="@/assets/img/ico-t.png" alt="" />
    </div>
    <ul>
      <li
        v-for="(item, index) in cgzsList"
        :key="item.ID"
        @mouseenter="hoverRoll(item)"
        class="wow fadeInLeft"
        :data-wow-delay="index / 5 + 's'"
      >
        <router-link
          :to="item.Url"
          :href="item.Url"
          @click.native="OpenLink(item.Url)"
        >
          <div class="time">
            <p>{{ setTimeformat(item.ShowTime, "dd") }}</p>
            <span>{{ setTimeformat(item.ShowTime, "yyyy-mm") }}</span>
          </div>
          <div class="textBox">
            <h3 class="title txt-cut1">{{ item.Title }}</h3>
            <p class="txt-cut2">{{ item.Describe }}</p>
          </div>
        </router-link>
      </li>
    </ul>
    <div class="more">
      <router-link :to="moreLink">
        <p>查看更多></p>
      </router-link>
    </div>
  </div>
</template>
<script>
export default {
  name: "cgzs",
  props: {
    cgzsList: {
      // 图片列表
      type: Array,
      default: () => [],
    },
    moreLink: {
      type: String,
      default: "",
    },
    styles: {
      type: Object,
      default: () => {
        return {
          width: 1920,
          height: 500,
        };
      },
    },
  },
  data() {
    return {
      showItem: this.dataList ? this.dataList[0] : null,
    };
  },
  methods: {
    setTimeformat(_data, _format = "yyyy-mm-dd") {
      return _format
        .replace(/YYYY/i, _data.substr(0, 4))
        .replace(/MM/i, _data.substr(5, 2))
        .replace(/DD/i, _data.substr(8, 2));
    },
    hoverRoll(_data) {
      this.showItem = _data;
    },
  },
};
</script>
<style lang="less" scoped >
.cgzs {
  margin-bottom: 85px;
  ul {
    width: 1200px;
    height: auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    li {
      width: 580px;
      height: 130px;
      margin: 0;
      margin-bottom: 30px;
      &:last-child,
      &:nth-last-child(2) {
        margin-bottom: 0px;
      }
      &:hover {
        a {
          .textBox {
            h3 {
              color: #0384c6;
            }
          }
        }
      }
      a {
        width: 100%;
        height: 100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .time {
          width: 120px;
          height: 130px;
          background-color: #0384c6;
          p {
            font-size: 46px;
            font-weight: bold;
            font-stretch: normal;
            line-height: 1;
            letter-spacing: 5px;
            color: #ffffff;
            margin-top: 25px;
            text-align: center;
          }
          span {
            font-size: 14px;
            font-weight: bold;
            font-stretch: normal;
            line-height: 1;
            letter-spacing: 1px;
            color: #ffffff;
            display: block;
            margin-top: 15px;
            text-align: center;
          }
        }
        .textBox {
          width: 460px;
          height: 100%;
          padding: 25px 30px;
          background-color: #fafafa;
          box-sizing: border-box;
          h3 {
            font-size: 18px;
            font-weight: 600;
            font-stretch: normal;
            line-height: 36px;
            letter-spacing: 2px;
            color: #333333;
          }
          p {
            font-size: 16px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 24px;
            letter-spacing: 2px;
            color: #666666;
          }
        }
      }
    }
  }
  .more {
    width: 150px;
    height: 50px;
    border-radius: 5px;
    margin: 0 auto;
    border: solid 1px #0376be;
    box-sizing: border-box;
    margin-top: 40px;
    padding: 0;
    a {
      display: block;
      p {
        font-size: 18px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 50px;
        letter-spacing: 2px;
        color: #0376be;
        text-align: center;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/cgzs.vue